module.exports = __webpack_public_path__ + "static/media/spider.93df7174.svg";